import { Spin } from 'antd'
import CustomButton from 'components/atoms/custom-button'
import Footer from 'components/molecules/Footer'
import Header from 'components/molecules/Header'
import ProfileSidebar from 'components/organisms/ProfileSidebar'
import SectionLayout from 'components/templates/SectionLayout'
import { typeUserConst } from 'constant'
import useAdvisor from 'hooks/useAdvisor'
import useAuth from 'hooks/useAuth'
import React, { Suspense } from 'react'
import { MdInfo } from 'react-icons/md'
import { Navigate, Outlet } from 'react-router-dom'
import WhatsappButton from 'components/atoms/WhatsappButton'
import { ScrollToTop } from 'utils/ScrollToTop'
import PopupNotification from 'components/organisms/PopupNotification'

const ProfileLayout = () => {
  const { userType } = useAuth()
  if (userType === typeUserConst.UNDECIDED) {
    return <Navigate to={'/onboarding'} replace={true} />
  }
  const { navigateToProfileAdvisor, isProfileAdvisorNotFilled } = useAdvisor()
  return (
    <div className="min-h-screen overflow-x-hidden">
      <PopupNotification />
      <ScrollToTop />
      {/* Warning Advisor Profile */}
      {isProfileAdvisorNotFilled() ? (
        <div className="h-[56px] bg-surface-warning-dark w-full flex justify-center items-center py-4 gap-4">
          <MdInfo className="fill-white" size={26} />
          <span className="text-white font-medium text-base">
            Lengkapi Profil Advisor Anda untuk mulai menampilkannya kepada Pembeli & Penjual
            potensial!
          </span>
          <CustomButton
            onClick={navigateToProfileAdvisor}
            className="w-fit h-fit py-1 px-1 text-sm"
            type="plain">
            Lengkapi Profil Anda Sekarang
          </CustomButton>
        </div>
      ) : null}
      <Header />
      <SectionLayout className="grid grid-cols-1 lg:grid-cols-[200px_1fr] xl:grid-cols-[300px_1fr] gap-8">
        {/* Sidebar */}
        <div className="w-full h-full">
          <ProfileSidebar />
        </div>
        <div className="w-full h-full">
          <Suspense
            fallback={
              <div
                className="
        w-full h-screen flex justify-center items-center">
                <Spin size="large" spinning={true}></Spin>
              </div>
            }>
            <Outlet />
          </Suspense>
        </div>
      </SectionLayout>
      <WhatsappButton />
      <Footer />
    </div>
  )
}

export default ProfileLayout
